import { toThreeDecimalsFixed } from 'utils/helpers'
import { DeliveryTicketDetails } from '../../interfaces'

export const toTableRowItems = (items: DeliveryTicketDetails[]) =>
  items.map((item: DeliveryTicketDetails) => ({
    id: item.id,
    externalOrderId: item.externalOrderId ?? '',
    originalOrderId: item.originalOrderId ?? '',
    supportCode: item.supportCode ?? '',
    heterogeneousCode: item.heterogeneousCode ?? '',
    expectedSupportType: item.expectedSupportType ?? '',
    secondarySupportType: item.secondarySupportType ?? '',
    supportStatus: item.supportStatus ?? '',
    supportStatusValue: item.supportStatusValue,
    eanCode: item.eanCode ?? '',
    eanReceived: item.eanReceived ?? '',
    productCode: item.productCode ?? '',
    productName: item.productName ?? '',
    priorityForSale: item.priorityForSale ?? false,
    measureUnit: item.measureUnit ?? '',
    deliveredQuantity:
      item.deliveredQuantity !== null ? toThreeDecimalsFixed(item.deliveredQuantity) : '',
    totalDeliveredQuantity:
      item.totalDeliveredQuantity !== null ? toThreeDecimalsFixed(item.totalDeliveredQuantity) : '',
    qualitativeQuantity:
      item.qualitativeQuantity !== null ? toThreeDecimalsFixed(item.qualitativeQuantity) : '',
    defectQuantity: item.defectQuantity !== null ? toThreeDecimalsFixed(item.defectQuantity) : '',
    missingQuantity:
      item.missingQuantity !== null ? toThreeDecimalsFixed(item.missingQuantity) : '',
    defectReason: item.defectReason ?? '',
    recommendedScanType: item.recommendedScanType ?? '',
    scanType: item.scanType ?? '',
    secondarySupportNumber: item.secondarySupportNumber ?? '',
    shortDlc: item.shortDlc ?? false,
    dlcDate: item.dlcDate ?? '',
    dlcDateExcel: item.dlcDateExcel ?? '',
    batch: item.batch ?? '',
    sensitive: item.sensitive ?? false,
    verified: item.verified ?? false,
    missing: item.missing ?? false,
    shopName: item.shopName ?? '',
    receptionDate: item.receptionDate ?? '',
    lifetimePercentage: item.lifetimePercentage ?? '',
    sgr: item.sgr ?? false,
    defect: item.defect ?? false,
    canBeSentToMeti: item.canBeSentToMeti ?? false
  }))
